import { render, staticRenderFns } from "./VeDividerBlock.vue?vue&type=template&id=08973d41&scoped=true"
import script from "./VeDividerBlock.vue?vue&type=script&lang=js"
export * from "./VeDividerBlock.vue?vue&type=script&lang=js"
import style0 from "./VeDividerBlock.vue?vue&type=style&index=0&id=08973d41&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08973d41",
  null
  
)

export default component.exports